<template>
    <div class="ele-pagination">
        <template v-if="lastPage > 1">
            <div class="btn btn-pagination btn-pagination-prev"
            :class="[ (currentPage == 1) ? 'invisible' : '' ]"
            @click="prevPage_Click()">
                <i class="fa fa-chevron-left"></i>
            </div>

            <ul class="ele-pagination-list">
                <li v-for="n in listPage" :key="n">
                    <button class="btn btn-pagination" @click="changePage_Click(n)"
                    :class="[ (currentPage == n) ? 'is-active' : '' ]" >{{ n }}</button>
                </li>
            </ul>

            <template v-if="currentPage < lastPage">
                <div class="btn btn-pagination btn-pagination-next"
                @click="nextPage_Click()">
                    <i class="fa fa-chevron-right"></i>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                pageLimit: 11,
                listPage: [],
                startPage: 0,
                endPage: 0,
                halfPage: 0,
            }
        },
        mounted() {},
        created() {},
        computed: {},
        methods: {
            bindListPageNo() {
                this.halfPage = Math.floor(this.pageLimit / 2);
                this.startPage = ((this.currentPage - this.halfPage) < 1)
                    ? 1
                    : this.currentPage - this.halfPage;
                let greaterPage = (this.currentPage <= this.halfPage) ? this.pageLimit - this.currentPage : this.halfPage;
                this.endPage = ((this.currentPage + greaterPage) > this.lastPage)
                    ? this.lastPage
                    : this.currentPage + greaterPage;
                this.listPage = [];
                for (let index = this.startPage; index <= this.endPage; index++) {
                    this.listPage.push(index);
                }
            },
            changePage_Click(pageNo) {
                this.$emit('changePage', pageNo);
            },
            prevPage_Click() {
                this.$emit('prevPage');
            },
            nextPage_Click() {
                this.$emit('nextPage');
            },
        },
        props: {
            lastPage: {
                type: Number,
                default: 1,
            },
            currentPage: {
                type: Number,
                default: 1,
            },
        }
    }
</script>

<style>
    #tb_movement tbody tr {
        cursor: pointer;
    }
</style>
